import React, { useState, useEffect } from 'react'
import "./Scroll.scss"

const ScrollTop = ({
    showBelow,
}) => {

    const [show, setShow] = useState(showBelow ? false : true)

    const handleScroll = () => {
        if (window.pageYOffset > showBelow) {
            if (!show) setShow(true)
        } else {
            if (show) setShow(false)
        }
    }

    const handleClick = () => {
        window[`scrollTo`]({ top: 0, behavior: `smooth` })
    }

    useEffect(() => {
        if (showBelow) {
            window.addEventListener(`scroll`, handleScroll)
            return () => window.removeEventListener(`scroll`, handleScroll)
        }
    })

    return (
        <div>
            {show &&
                <img 
                    onClick={handleClick} 
                    style={{ cursor: "pointer" }} 
                    className="scroll-to-top" 
                    aria-label="to top" 
                    component="span" 
                    src="https://img.icons8.com/color/60/000000/circled-up-2--v1.png" 
                />
            }
        </div>
    )
}

export default ScrollTop